import React, { useRef } from 'react';
import useGsap from '../../motion/useGsap';
import { prefersReducedMotion } from '../../motion/tokens';

// Line-by-line clip reveal. `lines` is an array of strings so the break
// points are authored, not left to the browser. Plays once on mount
// (hero) or on enter when `onEnter` is true.
export default function SplitHeading({ as: Tag = 'h1', lines, className = '', onEnter = false, delay = 0 }) {
  const ref = useRef(null);
  useGsap(ref, (gsap, ScrollTrigger) => {
    if (prefersReducedMotion()) return;
    const spans = ref.current.querySelectorAll('.split-line > span');
    gsap.set(spans, { yPercent: 110, rotate: 2, transformOrigin: 'left top' });
    const tween = gsap.to(spans, {
      yPercent: 0,
      rotate: 0,
      duration: 1.1,
      ease: 'expo.out',
      stagger: 0.09,
      delay,
      paused: onEnter,
    });
    if (onEnter) {
      ScrollTrigger.create({ trigger: ref.current, start: 'top 85%', once: true, onEnter: () => tween.play() });
    }
  }, [lines.join('|')]);
  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span className="split-line" key={i}>
          <span>{line}</span>
        </span>
      ))}
    </Tag>
  );
}
